import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { BankreaderService } from '../../services/Bankreader';
import { defaultBankMode, saveRequest } from '../../redux/requestSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES_PATH } from '../../utils/constants';
import { RequestType } from '../../models/RequestType';
import { AxiosError } from 'axios';
import pepperLogo from '../../assets/images/PepperLogo.svg';
import { ErrorType } from '../../models/ErrorType';
import { sendError } from '../../redux/errorSlice';
import { isLoading } from '../../redux/loaderSlice';
import SecurityService from '../../services/Security';
import { StorageService } from '../../services/Storage';
import { isFlowStep, isPepperOne, showSeniorMode } from '../../redux/paramsSlice';
import { TokenType } from '../../models/TokenType';


export const Landing: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const search = useLocation().search;
    const uuid = new URLSearchParams(search).get('uuid');
    const token = new URLSearchParams(search).get('lead_token');
    const isSenior = new URLSearchParams(search).get('issenior');
    const pepperOne = new URLSearchParams(search).get('pepperone');
    const flowStep = new URLSearchParams(search).get('flowstep');

    const getBankreader = async () => {
        const store = StorageService.getPepperStore();
        if (uuid || store && store.creditProposalId) {
            const creditProposalId = uuid || store.creditProposalId;
            BankreaderService.getBankConfig(creditProposalId)
                .then((data: RequestType) => {
                    StorageService.clearError();
                    dispatch(saveRequest(data));
                    data.third_party_bank && dispatch(defaultBankMode(true));
                    navigate(ROUTES_PATH.ENTRY);
                })
                .catch((error: AxiosError) => {
                    dispatch(sendError(ErrorType.CONFIG_FAILED));
                    navigate(ROUTES_PATH.UNKNOWN_ERROR);
                });
        } else {
            dispatch(sendError(ErrorType.CONFIG_FAILED));
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
        }
    }

    const authenticateToken = async (token: any) => {
        let encodedToken = encodeURIComponent(token);
        encodedToken = encodedToken?.replace(new RegExp("%20", "g"), "%2B");
        const decodedToken = decodeURIComponent(encodedToken);
        SecurityService.authenticate(decodedToken)
            .then((response: TokenType) => {
                StorageService.setPepperStore({
                    accessToken: response.access_token,
                    creditProposalId: uuid,
                    isSenior: isSenior,
                    isPepperOne: pepperOne,
                    isFlowStep: flowStep
                })
                getBankreader();
            })
            .catch(() => {
                dispatch(sendError(ErrorType.CONFIG_FAILED));
                navigate(ROUTES_PATH.UNKNOWN_ERROR);
            })
    }

    useEffect(() => {
        dispatch(isLoading(true));
        const store = StorageService.getPepperStore();
        if (token || store) {
            if (isSenior) {
                dispatch(showSeniorMode(true));
            }
            if (pepperOne) {
                dispatch(isPepperOne(true))
            }
            if (flowStep) {
                dispatch(isFlowStep(false))
            }
            if (token) {
                authenticateToken(token);
            } else if (store && store.accessToken) {
                getBankreader();
            } else {
                dispatch(sendError(ErrorType.CONFIG_FAILED));
                navigate(ROUTES_PATH.UNKNOWN_ERROR);
            }
        } else {
            dispatch(sendError(ErrorType.CONFIG_FAILED));
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
        }
    }, [])
    return (
        <div className='pepper-landing-page'>
            <img src={pepperLogo} />
        </div>
    )
}
